export const FETCH_SUMMARY_DATA = "FETCH_SUMMARY_DATA";
export const FETCH_GOOGLE_ANALYTICS_DATA = "FETCH_GOOGLE_ANALYTICS_DATA";
